import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as Actions from './redux-actions.js';
import { DisappearedLoading } from 'react-loadingg';
import { useHistory } from 'react-router-dom';
import * as globals from './globals.js';
import * as helpers from './helpers.js';

import { InputOnlineGuide } from './FormInputComponents.jsx'
import './ModernHome.css' 

const OnlineGuidePage = () => {
  const dispatch = useDispatch();
  const reduxDictionary = useSelector(state => state.dictionary);
  const reduxBooking = useSelector(state => state.online_guide_booking);
  const serverReachable = useSelector(state => state.serverStatus);
  const history = useHistory();
  const inputFormRef = useRef(null);
  const bookConfirmationRef = useRef(null);
  const [click, setClick] = useState(0);
  const [paylater, setPaylater] = useState(0);
  const [bookinID, setBookingID] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  

  useEffect(() => {
    if (click === 1 && reduxBooking?.validation.status === true) {
      console.log('Booking submitted')
      setClick(0)
      handleSubmit()
    }
  }, [reduxBooking]);
  
  useEffect(() => {
    if (paylater === 1 && bookConfirmationRef.current) {
      bookConfirmationRef.current.scrollIntoView({ behavior: 'auto', block: 'start' });
    }
  }, [paylater]);
  

  const handleSubmit = () => {
    helpers.postAPI(
       { func: function(resp) {
            //After receiving response from server
            if (resp.status === 'OK') {
               console.log('OK', resp)
               
               if (reduxBooking.booking.payment_option === "BEFORE") {
                   history.push(`/payme/${reduxBooking.booking.total_price_azn}/AZN/${resp.booking_id}/${reduxBooking.booking.mail}/ONLINE_GUIDE`)
               } else {
                   setPaylater(1)
                   setBookingID(resp.booking_id)
               }
               
            } else if (resp.status === 'DUPLICATE') {
                 console.log(resp.message)
                 helpers.alertMessage('Sorry, a booking with overlapping dates has already been made for this email address. If you believe this is an error or need further assistance, please contact us at info@az-tur.com or our 24/7 WhatsApp.', globals.INFO, true, 60000)
            } else {
                 helpers.alertMessage(resp.message, globals.ERRO, true, 60000)
            }
        }.bind(this), 
         uri: globals.myAPIurl+'/bookguide',
         data: reduxBooking.booking
       })
  }


  const formatPricingInfo = () => {
    const parts = [];

    reduxDictionary.online_guide_price.forEach(({ min_days, max_days, price_azn, price_eur }) => {
      let daysRange;
      if (min_days === max_days) {
        daysRange = `${min_days} day`;
      } else if (max_days === 1000) {
        daysRange = `${min_days} days or more`;
      } else {
        daysRange = `${min_days} to ${max_days} days`;
      }

      parts.push(`<tr><td class="is-warning"><b>${daysRange}</b></td> <td class="is-warning"><b>${price_azn}</b> AZN <span class="is-size-7">(${(reduxDictionary.use_current_rates != "yes") ? price_eur : Math.ceil((price_azn / reduxDictionary.currency_exchange_rates.eur_price) * (1 + reduxDictionary.currency_exchange_rates.add_pct/100))} EUR)</span></td></tr>`);
    });

    return `<table class="table is-bordered is-striped is-narrow"><tbody> ${parts.join(' ')}</tbody></table>`;
  }

  const handleClick = async () => {
    setClick(1)
    await inputFormRef.current.saveData();
    let submit = await inputFormRef.current.validateData();
  };

  if (!reduxDictionary) {
    return (
      <div style={{ paddingBottom: '5rem' }} className="has-background-dark">
        <DisappearedLoading />
      </div>
    );
  }

  let booking_section

  /*
  if (reduxBooking?.validation.status === true) {
    handleSubmit()
  }
  */


  if (paylater === 1) {

    booking_section = (<div className="column">

    <div className="notification has-background-transparent has-text-centered is-size-5-desktop">
       <p>Thank you for your booking. Your booking number is <div class="tag">{bookinID}</div>.</p><br />
       <p>Check your email for confirmation and more details.</p><br />
       <p>We will send you payment instructions on the end of your last day.</p>
    </div>
    
  </div>)

  } else {

  booking_section = (<div className="column">

  <div
    className="notification has-background-transparent has-text-centered is-size-5-desktop"
    dangerouslySetInnerHTML={{ __html: helpers.cnt('oguide_19') }}
  ></div>

  <InputOnlineGuide forwardedRef={inputFormRef}/>

  <div className="field centered" style={{ margin: '3rem' }}>
    <div className="control">
      <button
        disabled={!serverReachable}
        className="button is-large is-light is-rounded is-outlined"
        onClick={handleClick}
      >
        <span className="icon is-large">
          <i className="fas fa-handshake"></i>
        </span>
        <span>Book it</span>
      </button>
    </div>
  </div>
</div>)

  }

  return (
    <div className="modern-home" style={{ marginBottom: '5rem' }}>
      {/* Hero Section */}
      <section className="hero is-fullheight-with-navbar modern-hero-guide">
        <div className="hero-body">
          <div className="container">
            <div className="columns is-vcentered">
              <div className="column is-6">
                <div className="hero-content">
                  <div className="tag is-warning is-large mb-4">
                    <span className="icon"><i className="fas fa-mobile-alt"></i></span>
                    <span>NEW SERVICE</span>
                  </div>
                  <h1 className="modern-title">
                    Your Personal <span className="highlight">Online Guide</span> in Azerbaijan
                  </h1>
                  <p className="modern-subtitle">
                    Explore Azerbaijan with confidence. Get instant answers, local tips, and personalized recommendations via WhatsApp - available 24/7 throughout your stay.
                  </p>
                  <div className="hero-buttons">
                    <button 
                      className="button is-warning is-large modern-btn"
                      onClick={()=>{bookConfirmationRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })}}
                    >
                      <span className="icon"><i className="fas fa-calendar-check"></i></span>
                      <span>Book Now</span>
                    </button>
                    <a href="https://wa.me/994502284849" className="button is-light is-large modern-btn-outline" onClick={() => window.gtag_report_conversion && window.gtag_report_conversion(undefined, 'whatsapp_' + Date.now())}>
                      <span className="icon"><i className="fab fa-whatsapp"></i></span>
                      <span>Ask Questions</span>
                    </a>
                  </div>
                </div>
              </div>
              
              <div className="column is-6">
                <div className="hero-image-container">
                  <div className="floating-card">
                    <img src="https://aztur-global.s3.eu-central-1.amazonaws.com/whatsapp_cha2.png" alt="Online Guide WhatsApp" className="hero-image" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section className="section modern-pricing-section">
        <div className="container">
          <div className="has-text-centered pricing-intro">
            <h2 className="section-title">Simple, Transparent Pricing</h2>
            <div
              className="section-subtitle pricing-description"
              dangerouslySetInnerHTML={{ __html: helpers.cnt('oguide_1') }}
            ></div>
          </div>
          
          <div className="columns is-centered">
            <div className="column is-10">
              <div className="pricing-cards-container">
                {reduxDictionary.online_guide_price.map((priceItem, index) => {
                  let daysRange;
                  let daysLabel;
                  if (priceItem.min_days === priceItem.max_days) {
                    daysRange = `${priceItem.min_days}`;
                    daysLabel = 'Day';
                  } else if (priceItem.max_days === 1000) {
                    daysRange = `${priceItem.min_days}+`;
                    daysLabel = 'Days';
                  } else {
                    daysRange = `${priceItem.min_days}-${priceItem.max_days}`;
                    daysLabel = 'Days';
                  }
                  
                  const priceEUR = (reduxDictionary.use_current_rates != "yes") 
                    ? priceItem.price_eur 
                    : Math.ceil((priceItem.price_azn / reduxDictionary.currency_exchange_rates.eur_price) * (1 + reduxDictionary.currency_exchange_rates.add_pct/100));
                  
                  return (
                    <div key={index} className="pricing-tier-card">
                      <div className="pricing-tier-header">
                        <div className="days-badge">
                          <div className="days-number">{daysRange}</div>
                          <div className="days-label">{daysLabel}</div>
                        </div>
                      </div>
                      <div className="pricing-tier-body">
                        <div className="price-main">
                          <span className="price-amount">{priceItem.price_azn}</span>
                          <span className="price-currency">AZN</span>
                        </div>
                        <div className="price-alt">
                          or {priceEUR} EUR
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
              
              <div className="payment-notice-modern">
                <div className="notice-icon-modern">
                  <i className="fas fa-shield-check"></i>
                </div>
                <div className="notice-content-modern">
                  <p className="notice-text-modern">
                    Pay securely on your last day, after experiencing our service. No upfront payment required!
                  </p>
                </div>
              </div>
              
              <div className="centered" style={{ marginTop: '3rem' }}>
                <button 
                  disabled={!serverReachable} 
                  className="button is-warning is-large modern-cta-btn"  
                  onClick={()=>{bookConfirmationRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })}}
                >
                  <span className="icon"><i className="fas fa-calendar-check"></i></span>
                  <span>Book Your Guide Now</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>


      {/* How It Works Section */}
      <section className="section modern-how-it-works">
        <div className="container">
          <div className="has-text-centered mb-6">
            <h2 className="section-title">How It Works</h2>
            <p className="section-subtitle">Get started in 3 simple steps</p>
          </div>
          
          <div className="columns is-vcentered">
            <div className="column is-8">
              <div className="steps-container">
                <div className="step-card">
                  <div className="step-number">1</div>
                  <div className="step-content">
                    <h3 className="step-title">Book Your Service</h3>
                    <div 
                      className="step-description"
                      dangerouslySetInnerHTML={{ __html: helpers.cnt('oguide_3').replace('{price}', `${reduxDictionary.online_guide_price[0].price_azn} <span class="ios">₼</span> (or ${reduxDictionary.online_guide_price[0].price_eur} &euro;)`) }}
                    ></div>
                  </div>
                </div>
                
                <div className="step-card">
                  <div className="step-number">2</div>
                  <div className="step-content">
                    <h3 className="step-title">Connect on WhatsApp</h3>
                    <div 
                      className="step-description"
                      dangerouslySetInnerHTML={{ __html: helpers.cnt('oguide_4') }}
                    ></div>
                  </div>
                </div>
                
                <div className="step-card">
                  <div className="step-number">3</div>
                  <div className="step-content">
                    <h3 className="step-title">Explore with Confidence</h3>
                    <div 
                      className="step-description"
                      dangerouslySetInnerHTML={{ __html: helpers.cnt('oguide_5') }}
                    ></div>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="column is-4">
              <div className="whatsapp-preview">
                <img src="https://aztur-global.s3.eu-central-1.amazonaws.com/whatsapp_cha2.png" alt="WhatsApp Guide" />
              </div>
            </div>
          </div>
        </div>
      </section>


      {/* Features Section */}
      <section className="section modern-features">
        <div className="container">
          {/* First Group - What You Can Expect */}
          <div className="feature-group">
            <div className="has-text-centered mb-6">
              <h2 className="section-title" dangerouslySetInnerHTML={{ __html: helpers.cnt('oguide_6') }}></h2>
            </div>
            
            <div className="columns is-multiline">
              <div className="column is-4">
                <div className="feature-card">
                  <div className="feature-icon">
                    <i className="fas fa-map-marked-alt"></i>
                  </div>
                  <div className="feature-content" dangerouslySetInnerHTML={{ __html: helpers.cnt('oguide_7') }}></div>
                </div>
              </div>
              
              <div className="column is-4">
                <div className="feature-card">
                  <div className="feature-icon">
                    <i className="fas fa-utensils"></i>
                  </div>
                  <div className="feature-content" dangerouslySetInnerHTML={{ __html: helpers.cnt('oguide_8') }}></div>
                </div>
              </div>
              
              <div className="column is-4">
                <div className="feature-card">
                  <div className="feature-icon">
                    <i className="fas fa-route"></i>
                  </div>
                  <div className="feature-content" dangerouslySetInnerHTML={{ __html: helpers.cnt('oguide_9') }}></div>
                </div>
              </div>
              
              <div className="column is-4">
                <div className="feature-card">
                  <div className="feature-icon">
                    <i className="fas fa-language"></i>
                  </div>
                  <div className="feature-content" dangerouslySetInnerHTML={{ __html: helpers.cnt('oguide_10') }}></div>
                </div>
              </div>
              
              <div className="column is-4">
                <div className="feature-card">
                  <div className="feature-icon">
                    <i className="fas fa-life-ring"></i>
                  </div>
                  <div className="feature-content" dangerouslySetInnerHTML={{ __html: helpers.cnt('oguide_11') }}></div>
                </div>
              </div>
            </div>
          </div>
          
          {/* Second Group - Why Choose Our Service */}
          <div className="feature-group" style={{ marginTop: '4rem' }}>
            <div className="has-text-centered mb-6">
              <h2 className="section-title" dangerouslySetInnerHTML={{ __html: helpers.cnt('oguide_13') }}></h2>
            </div>
            
            <div className="columns is-multiline">
              <div className="column is-4">
                <div className="feature-card">
                  <div className="feature-icon">
                    <i className="fas fa-camera"></i>
                  </div>
                  <div className="feature-content" dangerouslySetInnerHTML={{ __html: helpers.cnt('oguide_14') }}></div>
                </div>
              </div>
              
              <div className="column is-4">
                <div className="feature-card">
                  <div className="feature-icon">
                    <i className="fas fa-shopping-bag"></i>
                  </div>
                  <div className="feature-content" dangerouslySetInnerHTML={{ __html: helpers.cnt('oguide_15') }}></div>
                </div>
              </div>
              
              <div className="column is-4">
                <div className="feature-card">
                  <div className="feature-icon">
                    <i className="fas fa-ticket-alt"></i>
                  </div>
                  <div className="feature-content" dangerouslySetInnerHTML={{ __html: helpers.cnt('oguide_16') }}></div>
                </div>
              </div>
              
              <div className="column is-4">
                <div className="feature-card">
                  <div className="feature-icon">
                    <i className="fas fa-car"></i>
                  </div>
                  <div className="feature-content" dangerouslySetInnerHTML={{ __html: helpers.cnt('oguide_17') }}></div>
                </div>
              </div>
              
              <div className="column is-4">
                <div className="feature-card">
                  <div className="feature-icon">
                    <i className="fas fa-exclamation-triangle"></i>
                  </div>
                  <div className="feature-content" dangerouslySetInnerHTML={{ __html: helpers.cnt('oguide_18') }}></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Booking Section */}
      <section ref={bookConfirmationRef} className="section has-background-info has-text-light">
        <div className="columns is-centered">
          <div className="column is-2"></div>
          {booking_section}
          <div className="column is-2"></div>
        </div>
      </section>
    </div>
  );
};

export default OnlineGuidePage;
